import request from '../header';
import { dedupedRequest } from '../requestDedup';

/** Public config: min versions (PWA, Android, iOS) and store URLs. No auth. Used by PWA version check and native app update prompt. */
function getFrontendEnvironment() {
  return String(import.meta.env.VITE_ENVIRONMENT || 'production').trim().toLowerCase();
}

const getNativeAppVersion = dedupedRequest('native-app-version', () =>
  request.get('/config/native-app-version', { environment: getFrontendEnvironment() })
);

const getVersionControl = () =>
  request.get('/config/version-control', { environment: getFrontendEnvironment() });

const putVersionControl = (data) =>
  request.put('/config/version-control', {
    ...data,
    environment: getFrontendEnvironment(),
  });

const versionControlAPI = {
  getNativeAppVersion,
  getVersionControl,
  putVersionControl,
};
export default versionControlAPI;
